import { Link } from '@tanstack/react-router';
import { FaHome, FaMapMarkerAlt } from 'react-icons/fa';
import { SEO } from '@/components';

export function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to miweather.org for Michigan weather forecasts."
        path="/404"
      />
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="text-8xl mb-4">🌧️</div>
      <h1 className="text-4xl font-bold mb-2">404</h1>
      <p className="text-xl text-white/70 mb-6">
        Looks like this page got lost in a Michigan blizzard.
      </p>
      <div className="flex gap-4">
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2 bg-[var(--color-info)] hover:bg-[var(--color-info)]/80 rounded-lg font-medium transition-colors"
        >
          <FaHome /> Go Home
        </Link>
        <Link
          to="/weather/$locationId"
          params={{ locationId: 'detroit' }}
          className="flex items-center gap-2 px-4 py-2 stat-box hover:bg-white/10 rounded-lg font-medium transition-colors"
        >
          <FaMapMarkerAlt /> View Detroit Weather
        </Link>
      </div>
    </div>
    </>
  );
}
